import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

class Sort extends Component {

  doSortAction(sort) {
    const { location, history } = this.props;
    const params = new URLSearchParams(location.search);

    params.set('Keywords', this.props.words);
    params.set('sort', sort);
    params.set('start', 0);

    let iref_sort = sort === '1' ? 'pc_ss_score' : 'pc_ss_date';
    params.set('iref', iref_sort);

    history.push({
        search: params.toString(),
    });
    window.scrollTo(0, 0);
  }

  render(){
    
    return(
        <ul className="SortList">
            <li className={this.props.sort === '2' || this.props.sort === '' ? 'Selected' : ''}><a onClick={this.doSortAction.bind(this, '2')}>更新日時順</a></li>
            <li className={this.props.sort === '1' ? 'Selected' : ''}><a onClick={this.doSortAction.bind(this, '1')}>関連度順</a></li>
        </ul>
    );
  }
}
Sort.propTypes = {
    post: PropTypes.shape({
        words: PropTypes.string.isRequired,
        sort: PropTypes.string.isRequired
    })
}

// このコンポーネントで使いたいデータだけをstore(state)から取得する
function mapStateToProps(state){

  const length = state.posts.length;
  const currentState = state.posts[length - 1];

  if (currentState.items.goo) {
    return {
        words: currentState.items.goo.words,
        sort: currentState.items.goo.sort,
    }
  }
}

export default withRouter(connect(mapStateToProps)(Sort));